<template>
<div>
    <v-container fluid>
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg!=null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>

        <v-card class="box pa-4">
            <v-toolbar flat dense class="toolbar">
                <v-toolbar-title>Stock Register</v-toolbar-title>
                <v-divider class="mx-4" inset vertical></v-divider>
                <v-spacer></v-spacer>
            </v-toolbar>

            <!-- Date Range & Academic Year Toggle -->
            <v-row justify="center">
                <v-col cols="12" sm="4">
                    <v-radio-group v-model="filterType" row>
                        <v-radio label="Date Range Wise" value="dateRange"></v-radio>
                        <v-radio label="Academic Year Wise" value="academicYear"></v-radio>
                    </v-radio-group>
                </v-col>
            </v-row>

            <!-- Date Range Inputs -->
            <v-row justify="center" v-if="filterType === 'dateRange'">
                <v-col cols="12" sm="3">
                    <v-text-field label="From Date" rounded outlined dense type="date" persistent-hint hint="(Inclusive)" v-model="fromDate"></v-text-field>
                </v-col>

                <v-col cols="12" sm="3">
                    <v-text-field label="To Date" rounded outlined dense type="date" persistent-hint hint="(Exclusive)" v-model="toDate"></v-text-field>
                </v-col>
            </v-row>

            <!-- Academic Year Dropdown -->
            <v-row justify="center" v-else>
                <v-col cols="12" sm="3">
                    <v-autocomplete v-model="academicYear" rounded item-text="ay" item-value="id" :items="academicYears" label="Select Academic Year *" dense outlined></v-autocomplete>
                </v-col>
            </v-row>

            <!-- Dropdowns for Vendor, Shop, Item Category, Standard, Transaction Type -->
            <v-row justify="center" class="mt-4">
                <v-col cols="12" sm="1"></v-col>
                <v-col cols="12" sm="2">
                    <v-autocomplete v-model="vendor" rounded :items="vendors" item-text="company_name" item-value="id" label="Vendor *" dense outlined required></v-autocomplete>
                </v-col>

                <v-col cols="12" sm="2">
                    <v-autocomplete v-model="vendorShop" rounded :items="filteredSupplierShopList" item-text="name" item-value="id" label="Vendor Shop *" dense outlined required></v-autocomplete>
                </v-col>

                <v-col cols="12" sm="2">
                    <v-autocomplete v-model="itemCategory" rounded :items="itemCategories" item-text="name" item-value="id" label="Item Category *" dense outlined></v-autocomplete>
                </v-col>

                <v-col cols="12" sm="2">
                    <v-autocomplete v-model="standard" rounded :items="standards" item-text="standard" item-value="id" label="Standard *" dense outlined></v-autocomplete>
                </v-col>
                <v-col cols="12" sm="2">
                    <v-autocomplete v-model="transactionType" rounded :items="transactionTypes" item-text="name" item-value="id" label="Transaction Type *" dense outlined></v-autocomplete>
                </v-col>
            </v-row>

            <!-- Fetch Button -->
            <v-row justify="center">
                <v-btn color="primary" class="mt-4" @click="fetchData" :disabled="!isFetchEnabled">Fetch</v-btn>
            </v-row>
        </v-card>
        <v-row v-if="stockRegisterData != ''">
            <v-btn rounded small class="ml-5" color="success" outlined @click="fnExcelReport('my-table-id', 'Stock Register')"><v-icon color="success">mdi-export</v-icon>Export</v-btn>
        </v-row>
        <v-card class="box" v-if="stockRegisterData.length > 0">
            <v-data-table :headers="headers" :items="stockRegisterData" item-value="id" class="elevation-1" id="my-table-id" :search="search">
                <template v-slot:top>
                    <v-toolbar flat class="toolbar">
                        <v-toolbar-title>Stock Transactions</v-toolbar-title>
                        <v-divider class="mx-4" inset vertical></v-divider>
                        <v-spacer></v-spacer>
                        <v-text-field class="" v-model="search" background-color="white" append-icon="mdi-magnify" label="Search" style="margin-left: 200px;"
                        single-line hide-details></v-text-field>                        
                    </v-toolbar>
                </template>
                <template v-slot:[`item.sizeLabel`]="{ item }">
                    <span v-if="item.sizeLabel == null"
                        >--</span
                    >
                    <span v-else>{{ item.sizeLabel }}</span>
                </template>
                <template v-slot:[`item.sizeLabelType`]="{ item }">
                    <span v-if="item.sizeLabelType == null"
                        >--</span
                    >
                    <span v-else>{{ item.sizeLabelType }}</span>
                </template>
                <template v-slot:[`item.invoiceNo`]="{ item }">
                    <span v-if="item.invoiceNo == null"
                        >--</span
                    >
                    <span v-else>{{ item.invoiceNo }}</span>
                </template>
                <template v-slot:[`item.orderNo`]="{ item }">
                    <span v-if="item.orderNo == null"
                        >--</span
                    >
                    <span v-else>{{ item.orderNo }}</span>
                </template>
            </v-data-table>
        </v-card>
    </v-container>
</div> <!-- /. root div -->
</template>

<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
export default {
    data: () => ({
        loader: false,
        snackbar_msg: "",
        color: "",
        snackbar: false,
        overlay: false,
        filterType: "dateRange", // Default selection
        fromDate: new Date(new Date().getFullYear(), new Date().getMonth() - 0, 2).toISOString().substr(0, 10),
        toDate: new Date().toISOString().slice(0, 10),
        fromMenu: false,
        toMenu: false,
        academicYear: null,
        academicYears: [],
        search: "",
        vendor: null,
        vendors: [],

        vendorShop: null,
        vendorShops: [],

        itemCategory: null,
        itemCategories: [],

        standard: null,
        standards: [],

        transactionType: null,
        transactionTypes: [],
        stockRegisterData: [],
        headers: [{
                text: "SR.No",
                value: "srNo",
                align: "start",
                sortable: true
            },
            {
                text: "Vendor",
                value: "vendor",
                sortable: true
            },
            {
                text: "Vendor Shop",
                value: "vendorShop",
                sortable: true
            },
            {
                text: "Item Category",
                value: "itemCategory",
                sortable: true
            },
            {
                text: "Item Name",
                value: "itemName",
                sortable: true
            },
            {
                text: "Size Label Type",
                value: "sizeLabelType",
                sortable: true
            },
            {
                text: "Size Label",
                value: "sizeLabel",
                sortable: true
            },
            {
                text: "Academic Year",
                value: "academicYear",
                sortable: true
            },
            {
                text: "Transaction Type",
                value: "transactionType",
                sortable: true
            },
            {
                text: "Transaction Date",
                value: "transactionDate",
                sortable: true
            },
            {
                text: "Quantity",
                value: "quantity",
                sortable: true
            },
            {
                text: "Unit Price",
                value: "unitPrice",
                sortable: true
            },
            {
                text: "Total Cost",
                value: "totalCost",
                sortable: true
            },
            {
                text: "Tax",
                value: "tax",
                sortable: true
            },
            {
                text: "Grand Total",
                value: "grandTotal",
                sortable: true
            },
            {
                text: "Invoice No",
                value: "invoiceNo",
                sortable: true
            },
            {
                text: "Order No",
                value: "orderNo",
                sortable: true
            },
            {
                text: "Staff",
                value: "staff",
                sortable: true
            },
            {
                text: "Remark",
                value: "remark",
                sortable: true
            }
        ],
    }),
    methods: {
        fnExcelReport(id, name) {
            let tab_text = `<table border='1px'>
            <tr>
            <th>Sr. No.</th>
            <th>Vendor</th>
            <th>VendorShop</th>
            <th>Item Category</th>
            <th>Item Name</th>
            <th>Size Label Type</th>
            <th>Size Label</th>           
            <th>Academic Year</th>
            <th>Transaction Type</th>
            <th>Transaction Date</th>
            <th>Quantity</th>
            <th>Unit Price</th>
            <th>Total cost</th>
            <th>Tax</th>
            <th>Grand Total</th>
            <th>Invoice No</th>
            <th>Order No</th>
             <th>Staff</th>
            <th>Remark</th>
            </tr>`;

                this.stockRegisterData.forEach((s) => {
                    tab_text += `
            <tr>
                <td>${s.srNo}</td>
                <td>${s.vendor}</td>
                <td>${s.vendorShop}</td>
                <td>${s.itemCategory}</td>
                <td>${s.itemName}</td>
                <td>${s.sizeLabelType}</td>
                <td>${s.sizeLabel}</td>
                <td>${s.academicYear}</td>
                <td>${s.transactionType}</td>
                <td>${s.transactionDate}</td>
                <td>${s.quantity}</td>
                <td>${s.unitPrice}</td>
                <td>${s.totalCost}</td>
                <td>${s.tax}</td>
                <td>${s.grandTotal}</td>
                <td>${s.invoiceNo}</td>
                <td>${s.orderNo}</td>
                <td>${s.staff}</td>
                <td>${s.remark}</td>
            </tr>`;
                });

                tab_text += '</table>';

                const blob = new Blob([tab_text], {
                    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                });
                const filename = name + '.xls';

                if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                    // For IE
                    window.navigator.msSaveOrOpenBlob(blob, filename);
                } else {
                    // For modern browsers
                    const url = window.URL.createObjectURL(blob);
                    const a = document.createElement('a');
                    a.href = url;
                    a.download = filename;
                    a.click();
                    window.URL.revokeObjectURL(url);
                }
        },
        fetchData() {
            this.overlay = true; // Show loading overlay

            // Prepare payload based on the selected filter type
            let payload = {
                filterType: this.filterType,
                vendorId: this.vendor,
                vendorShopId: this.vendorShop,
                itemCategoryId: this.itemCategory,
                standardId: this.standard,
                transactionTypeId: this.transactionType,
            };

            if (this.filterType === "dateRange") {
                payload.fromDate = this.fromDate;
                payload.toDate = this.toDate;
            } else {
                payload.academicYearId = this.academicYear;
            }

            axios
                .post("EduStore/fetchStockRegister", payload)
                .then((res) => {
                    if (res.data.flag === "YES") {
                        this.stockRegisterData = res.data.stockData; // Assuming response contains the list
                    }else  if (res.data.flag === "No") {
                        this.showSnackbar("#b71c1c", res.data.snackbar);
                    }
                    else {
                        this.showSnackbar("#b71c1c", res.data.snackbar);
                    }
                })
                .catch(() => {
                    this.showSnackbar("#b71c1c", "Something went wrong!!!");
                })
                .finally(() => {
                    this.overlay = false; // Hide loading overlay
                });
        },

        onLoad() {
            axios.post("EduStore/getStockRegisterDetails")
                .then((res) => {
                    if (res.data.flag === "YES") {
                        this.vendors = res.data.invVendorList;
                        this.vendorShops = res.data.supplierShopList;
                        this.itemCategories = res.data.itemCategoryList
                        this.standards = res.data.standard_list
                        this.transactionTypes = res.data.stockTransactionTypelist
                        this.academicYears = res.data.ay_list
                        this.academicYear = res.data.current_ay
                    } else {
                        this.showSnackbar("#b71c1c", res.data.status_reason);
                    }
                })
                .catch(() => {
                    this.showSnackbar("#b71c1c", "Something went wrong!!!");
                    this.overlay = false;
                })
                .finally(() => {
                    this.overlay = false;
                });
        },
        showSnackbar(clr, msg) {
            this.snackbar = true;
            this.color = clr;
            this.snackbar_msg = msg;
        },
    },
    computed: {
        isFetchEnabled() {
            // Check if all required dropdowns are selected
            const isCommonFiltersSelected = !!this.vendor && !!this.vendorShop;

            if (this.filterType === "dateRange") {
                // Enable Fetch button only if Date Range AND all dropdowns are selected
                return !!this.fromDate && !!this.toDate && isCommonFiltersSelected;
            } else {
                // Enable Fetch button only if Academic Year AND all dropdowns are selected
                return !!this.academicYear && isCommonFiltersSelected;
            }
        },
        // Filter shop list based on selected vendor
        filteredSupplierShopList() {
            if (!this.vendor) return [];
            return this.vendorShops.filter(shop => shop.invvendorId === this.vendor);
        }
    },
    mounted() {
        this.onLoad();
    },
    watch: {},
};
</script>

<style scoped>
.required::after {
    content: " *";
    color: red;
}
</style>
